import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sub_menu_01" }
const _hoisted_2 = { class: "snb" }

import { computed } from "vue";
import { useStore } from "vuex";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useAuth } from "@/composables/useAuth";

export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

const { isLoggedIn } = useAuth();

const store = useStore();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: _normalizeClass({ active: _ctx.$route.path.includes(_unref(USER_ROUTES).NOTICE) })
        }, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).Notice.Path}`
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("공지사항")
            ])),
            _: 1
          }, 8, ["to"])
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass({ active: _ctx.$route.path.includes(_unref(USER_ROUTES).INQUIRY) })
        }, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).Inquiry.Path}`
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("문의하기")
            ])),
            _: 1
          }, 8, ["to"])
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass({ active: _ctx.$route.path.includes(_unref(USER_ROUTES).PRESS) })
        }, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).Press.Path}`
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("홍보자료실")
            ])),
            _: 1
          }, 8, ["to"])
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass({ active: _ctx.$route.path.includes(_unref(USER_ROUTES).QNA) })
        }, [
          _createVNode(_component_router_link, {
            to: `${_unref(USER_ROUTES).Qna.Path}`
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("FAQ")
            ])),
            _: 1
          }, 8, ["to"])
        ], 2)
      ])
    ])
  ]))
}
}

})